import React from "react";

interface LiveSessionProps {
  attendanceReport: any;
  selectedSession: string;
  onSessionChange: (session: string) => void;
  totalAttendance: number;
  attendanceGradient: string;
  attendanceValues: {
    full: number;
    acceptable: number;
    unacceptable: number;
  };
}

const LiveSession: React.FC<LiveSessionProps> = ({
  attendanceReport,
  selectedSession,
  onSessionChange,
  totalAttendance,
  attendanceGradient,
  attendanceValues,
}) => {
  return (
    <div className="attendance-section">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Attendance of live sessions</h3>
        <select
          className="form-select form-select-sm"
          style={{ width: "auto" }}
          value={selectedSession}
          onChange={(e) => onSessionChange(e.target.value)}
        >
          <option value="latest">Latest</option>
          <option value="all">All</option>
          {attendanceReport?.Session_title_dict && Object.keys(attendanceReport.Session_title_dict).map((sessionTitle) => (
            <option key={sessionTitle} value={sessionTitle}>
              {sessionTitle}
            </option>
          ))}
        </select>
      </div>
      <div className="attendance-chart">
        <div
          className="donut-chart"
          style={{
            background: totalAttendance === 0 ? "#808080" : attendanceGradient,
          }}
        >
          <div className="chart-center">{totalAttendance}</div>
        </div>
        <div className="chart-legend">
          <div className="legend-item">
            <div
              className="legend-color-bar"
              style={{ backgroundColor: "#4caf50" }}
            ></div>
            <span className="legend-number">{attendanceValues.full}</span>
            <span className="legend-text">Full (100%)</span>
          </div>
          <div className="legend-item">
            <div
              className="legend-color-bar"
              style={{ backgroundColor: "#42a5f5" }}
            ></div>
            <span className="legend-number">{attendanceValues.acceptable}</span>
            <span className="legend-text">Acceptable (&gt; 90%)</span>
          </div>
          <div className="legend-item">
            <div
              className="legend-color-bar"
              style={{ backgroundColor: "#ff9800" }}
            ></div>
            <span className="legend-number">{attendanceValues.unacceptable}</span>
            <span className="legend-text text-danger">
              Unacceptable (&lt; 90%)
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveSession;
